interface GetCurrencyCodeByCountryArgs {
  /** The country code to get the currency code for. */
  countryCode: string;
  /** The default currency code to use if the country code is not found. */
  defaultCurrencyCode?: string;
  /** A list of currency codes to allow. */
  whitelist?: string[];
}

export const COUNTRY_CURRENCY_MAP: {
  [key: string]: { country: string; countryCode: string; currency: string; currencyCode: string };
} = {
  AD: { country: 'Andorra', countryCode: 'AD', currency: 'Euros', currencyCode: 'EUR' },
  AE: {
    country: 'United Arab Emirates',
    countryCode: 'AE',
    currency: 'Dirham',
    currencyCode: 'AED',
  },
  AF: { country: 'Afghanistan', countryCode: 'AF', currency: 'Afghani', currencyCode: 'AFN' },
  AG: {
    country: 'Antigua and Barbuda',
    countryCode: 'AG',
    currency: 'East Caribbean Dollar',
    currencyCode: 'XCD',
  },
  AI: {
    country: 'Anguilla',
    countryCode: 'AI',
    currency: 'East Caribbean Dollar',
    currencyCode: 'XCD',
  },
  AL: { country: 'Albania', countryCode: 'AL', currency: 'Lek', currencyCode: 'ALL' },
  AM: { country: 'Armenia', countryCode: 'AM', currency: 'Dram', currencyCode: 'AMD' },
  AN: {
    country: 'Netherlands Antilles',
    countryCode: 'AN',
    currency: 'Netherlands Antilles Guilder',
    currencyCode: 'ANG',
  },
  AO: { country: 'Angola', countryCode: 'AO', currency: 'Angolan kwanza', currencyCode: 'AOA' },
  AQ: {
    country: 'Antarctica',
    countryCode: 'AQ',
    currency: 'Antarctican dollar',
    currencyCode: 'AQD',
  },
  AR: { country: 'Argentina', countryCode: 'AR', currency: 'Peso', currencyCode: 'ARS' },
  AS: { country: 'American Samoa', countryCode: 'AS', currency: 'Euros', currencyCode: 'EUR' },
  AT: { country: 'Austria', countryCode: 'AT', currency: 'Euros', currencyCode: 'EUR' },
  AU: {
    country: 'Australian',
    countryCode: 'AU',
    currency: 'Australian Dollars',
    currencyCode: 'AUD',
  },
  AW: {
    country: 'Aruba',
    countryCode: 'AW',
    currency: 'Netherlands Antilles Guilder',
    currencyCode: 'ANG',
  },
  AX: { country: 'Aland Islands', countryCode: 'AX', currency: 'Euro', currencyCode: 'EUR' },
  AZ: { country: 'Azerbaijan', countryCode: 'AZ', currency: 'Manat', currencyCode: 'AZN' },
  BA: {
    country: 'Bosnia and Herzegovina',
    countryCode: 'BA',
    currency: 'Bosnia and Herzegovina convertible mark',
    currencyCode: 'BAM',
  },
  BB: { country: 'Barbados', countryCode: 'BB', currency: 'Barbadian Dollar', currencyCode: 'BBD' },
  BD: { country: 'Bangladesh', countryCode: 'BD', currency: 'Taka', currencyCode: 'BDT' },
  BE: { country: 'Belgium', countryCode: 'BE', currency: 'Euros', currencyCode: 'EUR' },
  BF: {
    country: 'Burkina Faso',
    countryCode: 'BF',
    currency: 'CFA Franc BCEAO',
    currencyCode: 'XOF',
  },
  BG: { country: 'Bulgaria', countryCode: 'BG', currency: 'Lev', currencyCode: 'BGN' },
  BH: { country: 'Bahrain', countryCode: 'BH', currency: 'Bahraini Dinar', currencyCode: 'BHD' },
  BI: { country: 'Burundi', countryCode: 'BI', currency: 'Burundi Franc', currencyCode: 'BIF' },
  BJ: { country: 'Benin', countryCode: 'BJ', currency: 'CFA Franc BCEAO', currencyCode: 'XOF' },
  BL: { country: 'Saint Barthelemy', countryCode: 'BL', currency: 'Euro', currencyCode: 'EUR' },
  BM: { country: 'Bermuda', countryCode: 'BM', currency: 'Bermudian Dollar', currencyCode: 'BMD' },
  BN: {
    country: 'Brunei Darussalam',
    countryCode: 'BN',
    currency: 'Bruneian Dollar',
    currencyCode: 'BND',
  },
  BO: { country: 'Bolivia', countryCode: 'BO', currency: 'Boliviano', currencyCode: 'BOB' },
  BR: { country: 'Brazil', countryCode: 'BR', currency: 'Brazil', currencyCode: 'BRL' },
  BS: { country: 'Bahamas', countryCode: 'BS', currency: 'Bahamian Dollar', currencyCode: 'BSD' },
  BT: { country: 'Bhutan', countryCode: 'BT', currency: 'Indian Rupee', currencyCode: 'INR' },
  BV: {
    country: 'Bouvet Island',
    countryCode: 'BV',
    currency: 'Norwegian Krone',
    currencyCode: 'NOK',
  },
  BW: { country: 'Botswana', countryCode: 'BW', currency: 'Pula', currencyCode: 'BWP' },
  BY: { country: 'Belarus', countryCode: 'BY', currency: 'Belarus Ruble', currencyCode: 'BYR' },
  BZ: { country: 'Belize', countryCode: 'BZ', currency: 'Belizean Dollar', currencyCode: 'BZD' },
  CA: { country: 'Canada', countryCode: 'CA', currency: 'Canadian Dollar', currencyCode: 'CAD' },
  CC: {
    country: 'Cocos (Keeling) Islands',
    countryCode: 'CC',
    currency: 'Australian Dollars',
    currencyCode: 'AUD',
  },
  CD: {
    country: 'Congo (Kinshasa)',
    countryCode: 'CD',
    currency: 'Congolese Frank',
    currencyCode: 'CDF',
  },
  CF: {
    country: 'Central African Republic',
    countryCode: 'CF',
    currency: 'CFA Franc BEAC',
    currencyCode: 'XAF',
  },
  CG: {
    country: 'Congo Republic of the Democratic',
    countryCode: 'CG',
    currency: 'CFA Franc BEAC',
    currencyCode: 'XAF',
  },
  CH: { country: 'Switzerland', countryCode: 'CH', currency: 'Swiss Franc', currencyCode: 'CHF' },
  CI: {
    country: 'Ivory Coast',
    countryCode: 'CI',
    currency: 'CFA Franc BCEAO',
    currencyCode: 'XOF',
  },
  CK: {
    country: 'Cook Islands',
    countryCode: 'CK',
    currency: 'New Zealand Dollars',
    currencyCode: 'NZD',
  },
  CL: { country: 'Chile', countryCode: 'CL', currency: 'Chilean Peso', currencyCode: 'CLP' },
  CM: { country: 'Cameroon', countryCode: 'CM', currency: 'CFA Franc BEAC', currencyCode: 'XAF' },
  CN: { country: 'China', countryCode: 'CN', currency: 'Yuan Renminbi', currencyCode: 'CNY' },
  CO: { country: 'Colombia', countryCode: 'CO', currency: 'Peso', currencyCode: 'COP' },
  CR: {
    country: 'Costa Rica',
    countryCode: 'CR',
    currency: 'Costa Rican Colon',
    currencyCode: 'CRC',
  },
  CU: { country: 'Cuba', countryCode: 'CU', currency: 'Cuban Peso', currencyCode: 'CUP' },
  CV: { country: 'Cape Verde', countryCode: 'CV', currency: 'Escudo', currencyCode: 'CVE' },
  CX: {
    country: 'Christmas Island',
    countryCode: 'CX',
    currency: 'Australian Dollars',
    currencyCode: 'AUD',
  },
  CY: { country: 'Cyprus', countryCode: 'CY', currency: 'Cypriot Pound', currencyCode: 'CYP' },
  CZ: { country: 'Czech Republic', countryCode: 'CZ', currency: 'Koruna', currencyCode: 'CZK' },
  DE: { country: 'Germany', countryCode: 'DE', currency: 'Euros', currencyCode: 'EUR' },
  DJ: { country: 'Djibouti', countryCode: 'DJ', currency: 'Djiboutian Franc', currencyCode: 'DJF' },
  DK: { country: 'Denmark', countryCode: 'DK', currency: 'Danish Krone', currencyCode: 'DKK' },
  DM: {
    country: 'Dominica',
    countryCode: 'DM',
    currency: 'East Caribbean Dollar',
    currencyCode: 'XCD',
  },
  DO: {
    country: 'Dominican Republic',
    countryCode: 'DO',
    currency: 'Dominican Peso',
    currencyCode: 'DOP',
  },
  DZ: { country: 'Algeria', countryCode: 'DZ', currency: 'Algerian Dinar', currencyCode: 'DZD' },
  EC: { country: 'Ecuador', countryCode: 'EC', currency: 'Sucre', currencyCode: 'ECS' },
  EE: { country: 'Estonia', countryCode: 'EE', currency: 'Estonian Kroon', currencyCode: 'EEK' },
  EG: { country: 'Egypt', countryCode: 'EG', currency: 'Egyptian Pound', currencyCode: 'EGP' },
  EH: { country: 'Western Sahara', countryCode: 'EH', currency: 'Dirham', currencyCode: 'MAD' },
  ER: { country: 'Eritrea', countryCode: 'ER', currency: 'Ethiopian Birr', currencyCode: 'ETB' },
  ES: { country: 'Spain', countryCode: 'ES', currency: 'Euros', currencyCode: 'EUR' },
  ET: { country: 'Ethiopia', countryCode: 'ET', currency: 'Ethiopian Birr', currencyCode: 'ETB' },
  FI: { country: 'Finland', countryCode: 'FI', currency: 'Euros', currencyCode: 'EUR' },
  FJ: { country: 'Fiji', countryCode: 'FJ', currency: 'Fijian Dollar', currencyCode: 'FJD' },
  FK: {
    country: 'Falkland Islands (Malvinas)',
    countryCode: 'FK',
    currency: 'Falkland Pound',
    currencyCode: 'FKP',
  },
  FM: {
    country: 'Micronesia Federated States of',
    countryCode: 'FM',
    currency: 'USD',
    currencyCode: 'USD',
  },
  FO: {
    country: 'Faroe Islands',
    countryCode: 'FO',
    currency: 'Danish Krone',
    currencyCode: 'DKK',
  },
  FR: { country: 'France', countryCode: 'FR', currency: 'Euros', currencyCode: 'EUR' },
  GA: { country: 'Gabon', countryCode: 'GA', currency: 'CFA Franc BEAC', currencyCode: 'XAF' },
  GB: { country: 'United Kingdom', countryCode: 'GB', currency: 'Sterling', currencyCode: 'GBP' },
  GD: {
    country: 'Grenada',
    countryCode: 'GD',
    currency: 'East Caribbean Dollar',
    currencyCode: 'XCD',
  },
  GE: { country: 'Georgia', countryCode: 'GE', currency: 'Lari', currencyCode: 'GEL' },
  GF: { country: 'French Guiana', countryCode: 'GF', currency: 'Euros', currencyCode: 'EUR' },
  GG: { country: 'Guernsey', countryCode: 'GG', currency: 'Guernsey pound', currencyCode: 'GGP' },
  GH: { country: 'Ghana', countryCode: 'GH', currency: 'Ghana cedi', currencyCode: 'GHS' },
  GI: { country: 'Gibraltar', countryCode: 'GI', currency: 'Gibraltar Pound', currencyCode: 'GIP' },
  GL: { country: 'Greenland', countryCode: 'GL', currency: 'Danish Krone', currencyCode: 'DKK' },
  GM: { country: 'Gambia', countryCode: 'GM', currency: 'Dalasi', currencyCode: 'GMD' },
  GN: { country: 'Guinea', countryCode: 'GN', currency: 'Guinean Franc', currencyCode: 'GNF' },
  GP: { country: 'Guadeloupe', countryCode: 'GP', currency: 'Euros', currencyCode: 'EUR' },
  GQ: {
    country: 'Equatorial Guinea',
    countryCode: 'GQ',
    currency: 'CFA Franc BEAC',
    currencyCode: 'XAF',
  },
  GR: { country: 'Greece', countryCode: 'GR', currency: 'Euros', currencyCode: 'EUR' },
  GS: {
    country: 'South Georgia and the South Sandwich Islands',
    countryCode: 'GS',
    currency: 'Sterling',
    currencyCode: 'GBP',
  },
  GT: { country: 'Guatemala', countryCode: 'GT', currency: 'Quetzal', currencyCode: 'GTQ' },
  GU: { country: 'Guam', countryCode: 'GU', currency: 'USD', currencyCode: 'USD' },
  GW: {
    country: 'Guinea-Bissau',
    countryCode: 'GW',
    currency: 'CFA Franc BCEAO',
    currencyCode: 'XOF',
  },
  GY: { country: 'Guyana', countryCode: 'GY', currency: 'Guyanaese Dollar', currencyCode: 'GYD' },
  HK: { country: 'Hong Kong', countryCode: 'HK', currency: 'HKD', currencyCode: 'HKD' },
  HM: {
    country: 'Heard and Mc Donald Islands',
    countryCode: 'HM',
    currency: 'Australian Dollars',
    currencyCode: 'AUD',
  },
  HN: { country: 'Honduras', countryCode: 'HN', currency: 'Lempira', currencyCode: 'HNL' },
  HR: {
    country: 'Croatia (Hrvatska)',
    countryCode: 'HR',
    currency: 'Croatian Dinar',
    currencyCode: 'HRK',
  },
  HT: { country: 'Haiti', countryCode: 'HT', currency: 'Gourde', currencyCode: 'HTG' },
  HU: { country: 'Hungary', countryCode: 'HU', currency: 'Forint', currencyCode: 'HUF' },
  ID: {
    country: 'Indonesia',
    countryCode: 'ID',
    currency: 'Indonesian Rupiah',
    currencyCode: 'IDR',
  },
  IE: { country: 'Ireland', countryCode: 'IE', currency: 'Euros', currencyCode: 'EUR' },
  IL: { country: 'Israel', countryCode: 'IL', currency: 'Shekel', currencyCode: 'ILS' },
  IM: { country: 'Isle of Man', countryCode: 'IM', currency: 'Manx pound', currencyCode: 'GBP' },
  IN: { country: 'India', countryCode: 'IN', currency: 'Indian Rupee', currencyCode: 'INR' },
  IO: {
    country: 'British Indian Ocean Territory',
    countryCode: 'IO',
    currency: 'USD',
    currencyCode: 'USD',
  },
  IQ: { country: 'Iraq', countryCode: 'IQ', currency: 'Iraqi Dinar', currencyCode: 'IQD' },
  IR: {
    country: 'Iran (Islamic Republic of)',
    countryCode: 'IR',
    currency: 'Iranian Rial',
    currencyCode: 'IRR',
  },
  IS: { country: 'Iceland', countryCode: 'IS', currency: 'Icelandic Krona', currencyCode: 'ISK' },
  IT: { country: 'Italy', countryCode: 'IT', currency: 'Euros', currencyCode: 'EUR' },
  JE: { country: 'Jersey', countryCode: 'JE', currency: 'Sterling', currencyCode: 'GBP' },
  JM: { country: 'Jamaica', countryCode: 'JM', currency: 'Jamaican Dollar', currencyCode: 'JMD' },
  JO: { country: 'Jordan', countryCode: 'JO', currency: 'Jordanian Dinar', currencyCode: 'JOD' },
  JP: { country: 'Japan', countryCode: 'JP', currency: 'Japanese Yen', currencyCode: 'JPY' },
  KE: { country: 'Kenya', countryCode: 'KE', currency: 'Kenyan Shilling', currencyCode: 'KES' },
  KG: { country: 'Kyrgyzstan', countryCode: 'KG', currency: 'Som', currencyCode: 'KGS' },
  KH: { country: 'Cambodia', countryCode: 'KH', currency: 'Riel', currencyCode: 'KHR' },
  KI: {
    country: 'Kiribati',
    countryCode: 'KI',
    currency: 'Australian Dollars',
    currencyCode: 'AUD',
  },
  KM: { country: 'Comoros', countryCode: 'KM', currency: 'Comoran Franc', currencyCode: 'KMF' },
  KN: {
    country: 'Saint Kitts',
    countryCode: 'KN',
    currency: 'East Caribbean Dollar',
    currencyCode: 'XCD',
  },
  KP: { country: 'Korea North', countryCode: 'KP', currency: 'Won', currencyCode: 'KPW' },
  KR: { country: 'Korea South', countryCode: 'KR', currency: 'Won', currencyCode: 'KRW' },
  KW: { country: 'Kuwait', countryCode: 'KW', currency: 'Kuwaiti Dinar', currencyCode: 'KWD' },
  KY: {
    country: 'Cayman Islands',
    countryCode: 'KY',
    currency: 'Caymanian Dollar',
    currencyCode: 'KYD',
  },
  KZ: { country: 'Kazakhstan', countryCode: 'KZ', currency: 'Tenge', currencyCode: 'KZT' },
  LA: { country: 'Laos', countryCode: 'LA', currency: 'Lao kip', currencyCode: 'LAK' },
  LB: { country: 'Lebanon', countryCode: 'LB', currency: 'Lebanese Pound', currencyCode: 'LBP' },
  LC: {
    country: 'Saint Lucia',
    countryCode: 'LC',
    currency: 'East Caribbean Dollar',
    currencyCode: 'XCD',
  },
  LI: { country: 'Liechtenstein', countryCode: 'LI', currency: 'Swiss Franc', currencyCode: 'CHF' },
  LK: { country: 'Sri Lanka', countryCode: 'LK', currency: 'Rupee', currencyCode: 'LKR' },
  LR: { country: 'Liberia', countryCode: 'LR', currency: 'Liberian Dollar', currencyCode: 'LRD' },
  LS: { country: 'Lesotho', countryCode: 'LS', currency: 'Loti', currencyCode: 'LSL' },
  LT: { country: 'Lithuania', countryCode: 'LT', currency: 'Lita', currencyCode: 'LTL' },
  LU: { country: 'Luxembourg', countryCode: 'LU', currency: 'Euros', currencyCode: 'EUR' },
  LV: { country: 'Latvia', countryCode: 'LV', currency: 'Lat', currencyCode: 'LVL' },
  LY: {
    country: 'Libyan Arab Jamahiriya',
    countryCode: 'LY',
    currency: 'Libyan Dinar',
    currencyCode: 'LYD',
  },
  MA: { country: 'Morocco', countryCode: 'MA', currency: 'Dirham', currencyCode: 'MAD' },
  MC: { country: 'Monaco', countryCode: 'MC', currency: 'Euros', currencyCode: 'EUR' },
  MD: { country: 'Moldova Republic of', countryCode: 'MD', currency: 'Leu', currencyCode: 'MDL' },
  ME: { country: 'Montenegro', countryCode: 'ME', currency: 'Euro', currencyCode: 'EUR' },
  MF: {
    country: 'Saint Martin (French part)',
    countryCode: 'MF',
    currency: 'Netherlands Antillean guilder',
    currencyCode: 'ANG',
  },
  MG: { country: 'Madagascar', countryCode: 'MG', currency: 'Malagasy Franc', currencyCode: 'MGA' },
  MH: { country: 'Marshall Islands', countryCode: 'MH', currency: 'USD', currencyCode: 'USD' },
  MK: { country: 'Macedonia', countryCode: 'MK', currency: 'Denar', currencyCode: 'MKD' },
  ML: { country: 'Mali', countryCode: 'ML', currency: 'CFA Franc BCEAO', currencyCode: 'XOF' },
  MM: { country: 'Myanmar', countryCode: 'MM', currency: 'Kyat', currencyCode: 'MMK' },
  MN: { country: 'Mongolia', countryCode: 'MN', currency: 'Tugrik', currencyCode: 'MNT' },
  MO: {
    country: 'Macao S.A.R.',
    countryCode: 'MO',
    currency: 'Macanese pataca',
    currencyCode: 'MOP',
  },
  MP: {
    country: 'Northern Mariana Islands',
    countryCode: 'MP',
    currency: 'USD',
    currencyCode: 'USD',
  },
  MQ: { country: 'Martinique', countryCode: 'MQ', currency: 'Euros', currencyCode: 'EUR' },
  MR: { country: 'Mauritania', countryCode: 'MR', currency: 'Ouguiya', currencyCode: 'MRO' },
  MS: {
    country: 'Montserrat',
    countryCode: 'MS',
    currency: 'East Caribbean Dollar',
    currencyCode: 'XCD',
  },
  MT: { country: 'Malta', countryCode: 'MT', currency: 'Maltese Lira', currencyCode: 'MTL' },
  MU: { country: 'Mauritius', countryCode: 'MU', currency: 'Mauritian Rupee', currencyCode: 'MUR' },
  MV: { country: 'Maldives', countryCode: 'MV', currency: 'Rufiyaa', currencyCode: 'MVR' },
  MW: { country: 'Malawi', countryCode: 'MW', currency: 'Malawian Kwacha', currencyCode: 'MWK' },
  MX: { country: 'Mexico', countryCode: 'MX', currency: 'Peso', currencyCode: 'MXN' },
  MY: { country: 'Malaysia', countryCode: 'MY', currency: 'Ringgit', currencyCode: 'MYR' },
  MZ: { country: 'Mozambique', countryCode: 'MZ', currency: 'Metical', currencyCode: 'MZN' },
  NA: { country: 'Namibia', countryCode: 'NA', currency: 'Dollar', currencyCode: 'NAD' },
  NC: { country: 'New Caledonia', countryCode: 'NC', currency: 'CFP Franc', currencyCode: 'XPF' },
  NE: { country: 'Niger', countryCode: 'NE', currency: 'CFA Franc BCEAO', currencyCode: 'XOF' },
  NF: {
    country: 'Norfolk Island',
    countryCode: 'NF',
    currency: 'Australian Dollars',
    currencyCode: 'AUD',
  },
  NG: { country: 'Nigeria', countryCode: 'NG', currency: 'Naira', currencyCode: 'NGN' },
  NI: { country: 'Nicaragua', countryCode: 'NI', currency: 'Cordoba Oro', currencyCode: 'NIO' },
  NL: { country: 'Netherlands', countryCode: 'NL', currency: 'Euros', currencyCode: 'EUR' },
  NO: { country: 'Norway', countryCode: 'NO', currency: 'Norwegian Krone', currencyCode: 'NOK' },
  NP: { country: 'Nepal', countryCode: 'NP', currency: 'Nepalese Rupee', currencyCode: 'NPR' },
  NR: { country: 'Nauru', countryCode: 'NR', currency: 'Australian Dollars', currencyCode: 'AUD' },
  NU: { country: 'Niue', countryCode: 'NU', currency: 'New Zealand Dollars', currencyCode: 'NZD' },
  NZ: {
    country: 'New Zealand',
    countryCode: 'NZ',
    currency: 'New Zealand Dollars',
    currencyCode: 'NZD',
  },
  OM: { country: 'Oman', countryCode: 'OM', currency: 'Sul Rial', currencyCode: 'OMR' },
  PA: { country: 'Panama', countryCode: 'PA', currency: 'Balboa', currencyCode: 'PAB' },
  PE: { country: 'Peru', countryCode: 'PE', currency: 'Nuevo Sol', currencyCode: 'PEN' },
  PF: {
    country: 'French Polynesia',
    countryCode: 'PF',
    currency: 'CFP Franc',
    currencyCode: 'XPF',
  },
  PG: { country: 'Papua New Guinea', countryCode: 'PG', currency: 'Kina', currencyCode: 'PGK' },
  PH: { country: 'Philippines', countryCode: 'PH', currency: 'Peso', currencyCode: 'PHP' },
  PK: { country: 'Pakistan', countryCode: 'PK', currency: 'Rupee', currencyCode: 'PKR' },
  PL: { country: 'Poland', countryCode: 'PL', currency: 'Zloty', currencyCode: 'PLN' },
  PM: {
    country: 'Saint Pierre and Miquelon',
    countryCode: 'PM',
    currency: 'Euro',
    currencyCode: 'EUR',
  },
  PN: {
    country: 'Pitcairn',
    countryCode: 'PN',
    currency: 'New Zealand Dollars',
    currencyCode: 'NZD',
  },
  PR: { country: 'Puerto Rico', countryCode: 'PR', currency: 'USD', currencyCode: 'USD' },
  PS: {
    country: 'Palestinian Territory',
    countryCode: 'PS',
    currency: 'Jordanian dinar',
    currencyCode: 'JOD',
  },
  PT: { country: 'Portugal', countryCode: 'PT', currency: 'Euros', currencyCode: 'EUR' },
  PW: { country: 'Palau', countryCode: 'PW', currency: 'USD', currencyCode: 'USD' },
  PY: { country: 'Paraguay', countryCode: 'PY', currency: 'Guarani', currencyCode: 'PYG' },
  QA: { country: 'Qatar', countryCode: 'QA', currency: 'Rial', currencyCode: 'QAR' },
  RE: { country: 'Reunion', countryCode: 'RE', currency: 'Euros', currencyCode: 'EUR' },
  RO: { country: 'Romania', countryCode: 'RO', currency: 'Leu', currencyCode: 'RON' },
  RS: { country: 'Serbia', countryCode: 'RS', currency: 'Serbian dinar', currencyCode: 'RSD' },
  RU: { country: 'Russian Federation', countryCode: 'RU', currency: 'Ruble', currencyCode: 'RUB' },
  RW: { country: 'Rwanda', countryCode: 'RW', currency: 'Rwanda Franc', currencyCode: 'RWF' },
  SA: { country: 'Saudi Arabia', countryCode: 'SA', currency: 'Riyal', currencyCode: 'SAR' },
  SB: {
    country: 'Solomon Islands',
    countryCode: 'SB',
    currency: 'Solomon Islands Dollar',
    currencyCode: 'SBD',
  },
  SC: { country: 'Seychelles', countryCode: 'SC', currency: 'Rupee', currencyCode: 'SCR' },
  SD: { country: 'Sudan', countryCode: 'SD', currency: 'Dinar', currencyCode: 'SDG' },
  SE: { country: 'Sweden', countryCode: 'SE', currency: 'Krona', currencyCode: 'SEK' },
  SG: { country: 'Singapore', countryCode: 'SG', currency: 'Dollar', currencyCode: 'SGD' },
  SH: {
    country: 'Saint Helena',
    countryCode: 'SH',
    currency: 'Saint Helena pound',
    currencyCode: 'GBP',
  },
  SI: { country: 'Slovenia', countryCode: 'SI', currency: 'Euros', currencyCode: 'EUR' },
  SJ: {
    country: 'Svalbard and Jan Mayen Islands',
    countryCode: 'SJ',
    currency: 'Norwegian Krone',
    currencyCode: 'NOK',
  },
  SK: {
    country: 'Slovakia (Slovak Republic)',
    countryCode: 'SK',
    currency: 'Koruna',
    currencyCode: 'SKK',
  },
  SL: { country: 'Sierra Leone', countryCode: 'SL', currency: 'Leone', currencyCode: 'SLL' },
  SM: { country: 'San Marino', countryCode: 'SM', currency: 'Euros', currencyCode: 'EUR' },
  SN: { country: 'Senegal', countryCode: 'SN', currency: 'CFA Franc BCEAO', currencyCode: 'XOF' },
  SO: { country: 'Somalia', countryCode: 'SO', currency: 'Shilling', currencyCode: 'SOS' },
  SR: {
    country: 'Suriname',
    countryCode: 'SR',
    currency: 'Surinamese Guilder',
    currencyCode: 'SRD',
  },
  ST: {
    country: 'Sao Tome and Principe',
    countryCode: 'ST',
    currency: 'Dobra',
    currencyCode: 'STD',
  },
  SV: {
    country: 'El Salvador',
    countryCode: 'SV',
    currency: 'Salvadoran Colon',
    currencyCode: 'SVC',
  },
  SY: {
    country: 'Syrian Arab Republic',
    countryCode: 'SY',
    currency: 'Syrian Pound',
    currencyCode: 'SYP',
  },
  SZ: { country: 'Swaziland', countryCode: 'SZ', currency: 'Lilangeni', currencyCode: 'SZL' },
  TC: {
    country: 'Turks and Caicos Islands',
    countryCode: 'TC',
    currency: 'USD',
    currencyCode: 'USD',
  },
  TD: { country: 'Chad', countryCode: 'TD', currency: 'CFA Franc BEAC', currencyCode: 'XAF' },
  TF: {
    country: 'French Southern Territories',
    countryCode: 'TF',
    currency: 'Euros',
    currencyCode: 'EUR',
  },
  TG: { country: 'Togo', countryCode: 'TG', currency: 'CFA Franc BCEAO', currencyCode: 'XOF' },
  TH: { country: 'Thailand', countryCode: 'TH', currency: 'Baht', currencyCode: 'THB' },
  TJ: {
    country: 'Tajikistan',
    countryCode: 'TJ',
    currency: 'Tajikistan Ruble',
    currencyCode: 'TJS',
  },
  TK: {
    country: 'Tokelau',
    countryCode: 'TK',
    currency: 'New Zealand Dollars',
    currencyCode: 'NZD',
  },
  TM: { country: 'Turkmenistan', countryCode: 'TM', currency: 'Manat', currencyCode: 'TMT' },
  TN: { country: 'Tunisia', countryCode: 'TN', currency: 'Tunisian Dinar', currencyCode: 'TND' },
  TO: { country: 'Tonga', countryCode: 'TO', currency: 'PaÕanga', currencyCode: 'TOP' },
  TP: {
    country: 'East Timor',
    countryCode: 'TP',
    currency: 'Indonesian Rupiah',
    currencyCode: 'IDR',
  },
  TR: { country: 'Turkey', countryCode: 'TR', currency: 'Lira', currencyCode: 'TRY' },
  TT: {
    country: 'Trinidad and Tobago',
    countryCode: 'TT',
    currency: 'Trinidad and Tobago Dollar',
    currencyCode: 'TTD',
  },
  TV: { country: 'Tuvalu', countryCode: 'TV', currency: 'Australian Dollars', currencyCode: 'AUD' },
  TW: { country: 'Taiwan', countryCode: 'TW', currency: 'Dollar', currencyCode: 'TWD' },
  TZ: { country: 'Tanzania', countryCode: 'TZ', currency: 'Shilling', currencyCode: 'TZS' },
  UA: { country: 'Ukraine', countryCode: 'UA', currency: 'Hryvnia', currencyCode: 'UAH' },
  UG: { country: 'Uganda', countryCode: 'UG', currency: 'Shilling', currencyCode: 'UGX' },
  UM: {
    country: 'United States Minor Outlying Islands',
    countryCode: 'UM',
    currency: 'USD',
    currencyCode: 'USD',
  },
  US: { country: 'United States', countryCode: 'US', currency: 'USD', currencyCode: 'USD' },
  USAF: {
    country: 'US Armed Forces',
    countryCode: 'USAF',
    currency: 'US Dollar',
    currencyCode: 'USD',
  },
  UY: { country: 'Uruguay', countryCode: 'UY', currency: 'Peso', currencyCode: 'UYU' },
  UZ: { country: 'Uzbekistan', countryCode: 'UZ', currency: 'Som', currencyCode: 'UZS' },
  VA: {
    country: 'Vatican City State (Holy See)',
    countryCode: 'VA',
    currency: 'Euros',
    currencyCode: 'EUR',
  },
  VC: {
    country: 'Saint Vincent Grenadines',
    countryCode: 'VC',
    currency: 'East Caribbean Dollar',
    currencyCode: 'XCD',
  },
  VE: { country: 'Venezuela', countryCode: 'VE', currency: 'Bolivar', currencyCode: 'VEF' },
  VG: {
    country: 'Virgin Islands (British)',
    countryCode: 'VG',
    currency: 'USD',
    currencyCode: 'USD',
  },
  VI: { country: 'Virgin Islands (US)', countryCode: 'VI', currency: 'USD', currencyCode: 'USD' },
  VN: { country: 'Vietnam', countryCode: 'VN', currency: 'Dong', currencyCode: 'VND' },
  VU: { country: 'Vanuatu', countryCode: 'VU', currency: 'Vatu', currencyCode: 'VUV' },
  WF: {
    country: 'Wallis and Futuna Islands',
    countryCode: 'WF',
    currency: 'CFP Franc',
    currencyCode: 'XPF',
  },
  WS: { country: 'Samoa', countryCode: 'WS', currency: 'Euros', currencyCode: 'EUR' },
  YE: { country: 'Yemen', countryCode: 'YE', currency: 'Rial', currencyCode: 'YER' },
  YT: { country: 'Mayotte', countryCode: 'YT', currency: 'Euros', currencyCode: 'EUR' },
  ZA: { country: 'South Africa', countryCode: 'ZA', currency: 'Rand', currencyCode: 'ZAR' },
  ZM: { country: 'Zambia', countryCode: 'ZM', currency: 'Kwacha', currencyCode: 'ZMK' },
  ZW: { country: 'Zimbabwe', countryCode: 'ZW', currency: 'Zimbabwe Dollar', currencyCode: 'ZWD' },
};

export const CURRENCY_CODE_SYMBOL_MAP: Record<string, string> = {
  AED: 'د.إ',
  AFN: '؋',
  ALL: 'L',
  AMD: '֏',
  ANG: 'ƒ',
  AOA: 'Kz',
  ARS: '$',
  AUD: '$',
  AWG: 'ƒ',
  AZN: '₼',
  BAM: 'KM',
  BBD: '$',
  BDT: '৳',
  BGN: 'лв',
  BHD: '.د.ب',
  BIF: 'FBu',
  BMD: '$',
  BND: '$',
  BOB: '$b',
  BOV: 'BOV',
  BRL: 'R$',
  BSD: '$',
  BTC: '₿',
  BTN: 'Nu.',
  BWP: 'P',
  BYN: 'Br',
  BYR: 'Br',
  BZD: 'BZ$',
  CAD: '$',
  CDF: 'FC',
  CHE: 'CHE',
  CHF: 'CHF',
  CHW: 'CHW',
  CLF: 'CLF',
  CLP: '$',
  CNY: '¥',
  COP: '$',
  COU: 'COU',
  CRC: '₡',
  CUC: '$',
  CUP: '₱',
  CVE: '$',
  CZK: 'Kč',
  DJF: 'Fdj',
  DKK: 'kr',
  DOP: 'RD$',
  DZD: 'دج',
  EEK: 'kr',
  EGP: '£',
  ERN: 'Nfk',
  ETB: 'Br',
  ETH: 'Ξ',
  EUR: '€',
  FJD: '$',
  FKP: '£',
  GBP: '£',
  GEL: '₾',
  GGP: '£',
  GHC: '₵',
  GHS: 'GH₵',
  GIP: '£',
  GMD: 'D',
  GNF: 'FG',
  GTQ: 'Q',
  GYD: '$',
  HKD: '$',
  HNL: 'L',
  HRK: 'kn',
  HTG: 'G',
  HUF: 'Ft',
  IDR: 'Rp',
  ILS: '₪',
  IMP: '£',
  INR: '₹',
  IQD: 'ع.د',
  IRR: '﷼',
  ISK: 'kr',
  JEP: '£',
  JMD: 'J$',
  JOD: 'JD',
  JPY: '¥',
  KES: 'KSh',
  KGS: 'лв',
  KHR: '៛',
  KMF: 'CF',
  KPW: '₩',
  KRW: '₩',
  KWD: 'KD',
  KYD: '$',
  KZT: '₸',
  LAK: '₭',
  LBP: '£',
  LKR: '₨',
  LRD: '$',
  LSL: 'M',
  LTC: 'Ł',
  LTL: 'Lt',
  LVL: 'Ls',
  LYD: 'LD',
  MAD: 'MAD',
  MDL: 'lei',
  MGA: 'Ar',
  MKD: 'ден',
  MMK: 'K',
  MNT: '₮',
  MOP: 'MOP$',
  MRO: 'UM',
  MRU: 'UM',
  MUR: '₨',
  MVR: 'Rf',
  MWK: 'MK',
  MXN: '$',
  MXV: 'MXV',
  MYR: 'RM',
  MZN: 'MT',
  NAD: '$',
  NGN: '₦',
  NIO: 'C$',
  NOK: 'kr',
  NPR: '₨',
  NZD: '$',
  OMR: '﷼',
  PAB: 'B/.',
  PEN: 'S/.',
  PGK: 'K',
  PHP: '₱',
  PKR: '₨',
  PLN: 'zł',
  PYG: 'Gs',
  QAR: '﷼',
  RMB: '￥',
  RON: 'lei',
  RSD: 'Дин.',
  RUB: '₽',
  RWF: 'R₣',
  SAR: '﷼',
  SBD: '$',
  SCR: '₨',
  SDG: 'ج.س.',
  SEK: 'kr',
  SGD: 'S$',
  SHP: '£',
  SLL: 'Le',
  SOS: 'S',
  SRD: '$',
  SSP: '£',
  STD: 'Db',
  STN: 'Db',
  SVC: '$',
  SYP: '£',
  SZL: 'E',
  THB: '฿',
  TJS: 'SM',
  TMT: 'T',
  TND: 'د.ت',
  TOP: 'T$',
  TRL: '₤',
  TRY: '₺',
  TTD: 'TT$',
  TVD: '$',
  TWD: 'NT$',
  TZS: 'TSh',
  UAH: '₴',
  UGX: 'USh',
  USD: '$',
  UYI: 'UYI',
  UYU: '$U',
  UYW: 'UYW',
  UZS: 'лв',
  VEF: 'Bs',
  VES: 'Bs.S',
  VND: '₫',
  VUV: 'VT',
  WST: 'WS$',
  XAF: 'FCFA',
  XBT: 'Ƀ',
  XCD: '$',
  XOF: 'CFA',
  XPF: '₣',
  XSU: 'Sucre',
  XUA: 'XUA',
  YER: '﷼',
  ZAR: 'R',
  ZMW: 'ZK',
  ZWD: 'Z$',
  ZWL: '$',
};

/**
 * Get the currency code for a given country code. The country code is must be in
 * ISO 3166-1 alpha-2 format.
 * @param args Include the country code, default currency code, and a whitelist.
 */
export function getCurrencyCodeByCountry({
  countryCode,
  defaultCurrencyCode = 'USD',
  whitelist,
}: GetCurrencyCodeByCountryArgs): string {
  const currency = COUNTRY_CURRENCY_MAP[countryCode]?.currencyCode ?? defaultCurrencyCode;

  if (whitelist && !whitelist.includes(currency)) {
    return defaultCurrencyCode;
  }

  return currency;
}
